export interface IAdminRelativePerformance {
    date: string,
    rank: number,
    centerId: number,
    centerAlias: string,
    metric: string,
    value: string,
    rankInNetwork: string
}